import { HttpStatusCode } from 'axios';

import { INVALID_ACCESS_TOKEN, INVALID_ACCESS_TOKEN_MESSAGE } from '@/consts/auth-errors';

type ErrorBody = Record<string, unknown> & {
  message?: unknown;
  code?: unknown;
  clientMessage?: unknown;
};

export const isInvalidAccessToken = (status: number | undefined, data: unknown): boolean => {
  const body = data as ErrorBody | null | undefined;
  return (
    status === HttpStatusCode.Unauthorized &&
    (body?.message === INVALID_ACCESS_TOKEN || body?.code === INVALID_ACCESS_TOKEN)
  );
};

export const withInvalidAccessTokenMessage = (data: ErrorBody): ErrorBody => ({
  ...data,
  code: INVALID_ACCESS_TOKEN,
  message:
    typeof data.clientMessage === 'string' && data.clientMessage
      ? data.clientMessage
      : INVALID_ACCESS_TOKEN_MESSAGE,
});

export const resolveErrorBody = <T>(status: number, data: T): T =>
  isInvalidAccessToken(status, data)
    ? (withInvalidAccessTokenMessage(data as ErrorBody) as T)
    : data;
